import { getProspectReference } from "@utils/storage";
import { getEndpoint } from "./endpoint";
import { keycloakUtils } from "itsf-ui-common";
import { getAcquisitionType } from "@utils/acquisitionTypeUtils";

const MS_NAME = "eir-sales-facade";
const EIR_SALES_FACADE_ENDPOINT = getEndpoint(MS_NAME);

const getEirSalesFacadeWithAcquisitionTypeEndpoint = () =>
    keycloakUtils.isAuthenticated()
        ? `${EIR_SALES_FACADE_ENDPOINT}cross-sells/`
        : `${EIR_SALES_FACADE_ENDPOINT}prospects/`;

export const getCartRoute = (prospectReference: string) =>
    `${getEirSalesFacadeWithAcquisitionTypeEndpoint()}${prospectReference}/carts`;

export const getCustomerDetailsRoute = () =>
    `${getEirSalesFacadeWithAcquisitionTypeEndpoint()}${getProspectReference()}/contacts`;

export const getContactDetailsRoute = (contactUuid: string) => `${EIR_SALES_FACADE_ENDPOINT}contact/${contactUuid}`;

export const putCustomerDetailsRoute = () =>
    `${getEirSalesFacadeWithAcquisitionTypeEndpoint()}${getProspectReference()}/contacts`;

export const postCustomerDetailsPhoneNumberRoute = (contactUuid: string) =>
    `${EIR_SALES_FACADE_ENDPOINT}contact/${contactUuid}/phone-number`;

export const addOfferRoute = (prospectReference: string) =>
    `${getEirSalesFacadeWithAcquisitionTypeEndpoint()}${prospectReference}/carts/offers`;

export const transferProspectToCrossSellRoute = (prospectReference: string) =>
    `${EIR_SALES_FACADE_ENDPOINT}prospects/${prospectReference}/transfer/gomo`;

export const deleteOfferRoute = (cartOfferId: number) =>
    `${getEirSalesFacadeWithAcquisitionTypeEndpoint()}${getProspectReference()}/carts/offers/${cartOfferId}`;

export const getPortinRoute = (cartOfferId: number) =>
    keycloakUtils.isAuthenticated()
        ? `${EIR_SALES_FACADE_ENDPOINT}cross-sells/${getProspectReference()}/carts/offers/${cartOfferId}/port-in`
        : `${EIR_SALES_FACADE_ENDPOINT}prospects/${getProspectReference()}/offers/${cartOfferId}/portin`;

export const portinRoute = (cartOfferId: number) =>
    keycloakUtils.isAuthenticated()
        ? `${EIR_SALES_FACADE_ENDPOINT}cross-sells/${getProspectReference()}/offers/${cartOfferId}/port-in`
        : `${EIR_SALES_FACADE_ENDPOINT}prospects/${getProspectReference()}/offers/${cartOfferId}/portin`;

export const validateVerificationCodeRoute = () => `${EIR_SALES_FACADE_ENDPOINT}portin/otp/validate`;

export const GET_VERIFICATION_CODE_ROUTE = `${EIR_SALES_FACADE_ENDPOINT}portin/otp`;

export const getDeviceDetailsApiRoute = (offerId: number) =>
    `${EIR_SALES_FACADE_ENDPOINT}sales/${getProspectReference()}/offers/${offerId}/device`;

export const getDevicesApiRoute = () => `${EIR_SALES_FACADE_ENDPOINT}device-details`;

export const getInclusiveEquipmentsApiRoute = (offerId: number) =>
    `${getEirSalesFacadeWithAcquisitionTypeEndpoint()}${getProspectReference()}/carts/offers/${offerId}/inclusive-equipments`;

export const getAscertainRoute = (prospectReference: string, offerId: number) =>
    `${EIR_SALES_FACADE_ENDPOINT}ascertain/gomo/prospects/${prospectReference}/offers/${offerId}`;

export const sendContract = () => `${EIR_SALES_FACADE_ENDPOINT}contract/send-contract`;

export const getSavePrequalRoute = (prospectReference: string) =>
    `${EIR_SALES_FACADE_ENDPOINT}prequal/gomo/prospects/${prospectReference}`;

export const viewAvailableAppointmentsRoute = (prospectReference: string, offerId: number) =>
    keycloakUtils.isAuthenticated()
        ? `${EIR_SALES_FACADE_ENDPOINT}cross-sells/${prospectReference}/carts/offers/${offerId}/available-appointments`
        : `${EIR_SALES_FACADE_ENDPOINT}prospects/${prospectReference}/offers/${offerId}/available-appointments`;

export const askAvailableAppointmentsRoute = (prospectReference: string, offerId: number) =>
    `${EIR_SALES_FACADE_ENDPOINT}gomo/${prospectReference}/offers/${offerId}/available-appointments?acquisitionType=${getAcquisitionType()}`;

export const addInstallationAppointmentRoute = (prospectReference: string, offerId: number) =>
    keycloakUtils.isAuthenticated()
        ? `${EIR_SALES_FACADE_ENDPOINT}cross-sells/${prospectReference}/carts/offers/${offerId}/appointments`
        : `${EIR_SALES_FACADE_ENDPOINT}prospects/${prospectReference}/offers/${offerId}/appointments`;

export const updateActivationDateRoute = (prospectReference: string, offerId: number) =>
    `${getEirSalesFacadeWithAcquisitionTypeEndpoint()}${prospectReference}/carts/offers/${offerId}/activation-date`;

export const getSaveEmailRoute = (reference: string) =>
    `${EIR_SALES_FACADE_ENDPOINT}marketing/${reference}/email-to-contact`;

export const clearCartRoute = (prospectReference: string) => `${EIR_SALES_FACADE_ENDPOINT}cart/${prospectReference}`;

export const getOfferAddonRoute = (prospectReference: string, offerId: number) =>
    `${getEirSalesFacadeWithAcquisitionTypeEndpoint()}${prospectReference}/carts/offers/${offerId}/addons`;

export const postAddonRoute = (prospectReference: string, offerId: number) =>
    keycloakUtils.isAuthenticated()
        ? `${EIR_SALES_FACADE_ENDPOINT}cross-sells/${prospectReference}/carts/offers/${offerId}/addons`
        : `${EIR_SALES_FACADE_ENDPOINT}prospects/${prospectReference}/carts/offers/${offerId}/add-ons`;

export const deleteAddonRoute = (prospectReference: string, offerId: number, addonId: number) =>
    keycloakUtils.isAuthenticated()
        ? `${EIR_SALES_FACADE_ENDPOINT}cross-sells/${prospectReference}/carts/offers/${offerId}/addons/${addonId}`
        : `${EIR_SALES_FACADE_ENDPOINT}prospects/${prospectReference}/carts/offers/${offerId}/add-ons/${addonId}`;

export const getAvailableActivationDates = () => `${EIR_SALES_FACADE_ENDPOINT}available-activation-dates`;
